import { Navigate } from 'react-router-dom';
import { AppRoutes } from './_router/app.routes';

const RootPage = () => {
  return (
    <Navigate to={AppRoutes.WEBSHOP.STEP_1} />
  );
}

export default RootPage;
